<template>
	<div class="reportList">
	    <iframe :src="iframeSrc" frameborder="0" class="reportFrame"></iframe>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';

    // Reports are AppSmith-only (#1502). Each report is a page in the
    // `cs-reports (2)` AppSmith app on apreports2; the cs3 tile grid
    // (ReportsLanding.vue) deep-links here with ?page=<slug>-<pageId>. We build
    // the embed URL directly with the full param set — AppSmith drops query
    // params on in-app page transitions, so every report must load in its own
    // iframe with params, never by navigating between pages inside one iframe.
    const APPSMITH_BASE = 'https://apreports2.callsteward.com/app/cs-reports-2/';
    // Default page when /report-list/appsmith is opened without ?page — the
    // Monthly/Yearly Job Details report.
    const DEFAULT_PAGE = 'p-monthlyjob-69f896f4cf810d7e7c045f50';
    // Only embed pages we recognise (slug-pageId shape) to avoid building a URL
    // from an arbitrary query value.
    const PAGE_RE = /^p-[a-z0-9]+-[a-f0-9]{24}$/i;

    export default {
        computed: {
            ...mapGetters({
                userClientID: 'userClientID',
                getSubdomain: 'getSubdomain'
            }),
            iframeSrc() {
                const q = (this.$route && this.$route.query) || {};
                const page = PAGE_RE.test(q.page || '') ? q.page : DEFAULT_PAGE;
                const host = window.location.hostname;
                const tenant = host.endsWith('.ca') ? 'ca' : 'com';
                // sub_domain scopes the AppSmith report to the tenant. Prefer the
                // store's canonical subdomain; fall back to the host label so a
                // tenant-hosted report still scopes correctly when
                // user.main.subdomain has not populated yet. (#1502: an empty
                // sub_domain param rendered blank headers + 0 rows.)
                const sub = this.getSubdomain || host.split('.')[0] || '';
                const params = new URLSearchParams({
                    branch: 'main',
                    embed: 'true',
                    tenant: tenant,
                    sub_domain: sub,
                    client_id: this.userClientID || '',
                });
                return APPSMITH_BASE + page + '?' + params.toString();
            }
        }
    }
</script>

<style scoped>

/* Sit below cs3's fixed 60px header and fill the rest of the viewport exactly.
   box-sizing keeps the 60px offset + 20px gutter inside the 100vh box so the
   iframe's bottom never overflows the fold — AppSmith's table toolbar (search /
   filter / Download, rendered at the foot of the table widget) was being
   clipped when the old fixed 85vh height + 60px padding pushed it past the
   viewport. The iframe now gets the full remaining height and owns its own
   scroll. (#1502) */
.reportList {
    box-sizing: border-box;
    height: 100vh;
    padding: 60px 20px 0;
}

.reportFrame {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
}

</style>
